import AsideEditor from '@UI/editor/AsideEditor';
import type { EditAsideDescription } from '@nodeTypeConfig/configTypes';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsideDescription: React.FC<{
  config: EditAsideDescription;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const editHref = useEditHref();

  const initialValue = useInitialValue(config.property);

  const label = config.fullLabel ?? config.label;

  return (
    <>
      {label && <label className="control-label control-label-inline">{label}</label>}
      <AsideEditor
        placeholder={''}
        skey={getResourceKey(editHref)}
        initial={initialValue}
        field={config.property}
        readOnly={readonly}
        plainText={false}
        inline={false}
        showCharacterCount={true}
        height={config?.options?.height}
      />
    </>
  );
};

AsideDescription.displayName = 'AsideDescription';

export default AsideDescription;

AsideDescription.propTypes = {
  config: any,
  readonly: any,
};
